import type {
  SiteCmsBranding,
  SiteCmsMenuItem,
  SiteCmsPageDraft,
} from "../types/entities";
import { cmsDocumentReferences, cmsImageReferences } from "./content";

/** Locations within one saved draft or immutable snapshot. Never includes private paths. */
export function cmsResourceLocations(
  kind: "image" | "document",
  id: string,
  pages: readonly SiteCmsPageDraft[],
  menu: readonly SiteCmsMenuItem[],
  branding?: Partial<SiteCmsBranding> | null,
): string[] {
  const result: string[] = [];
  if (kind === "image") {
    if (branding?.logoImageId === id) result.push("Apparence · logo");
    if (branding?.coverImageId === id) result.push("Apparence · bannière");
    if (branding?.backgroundImageId === id)
      result.push(
        branding.layoutMode === "widescreen"
          ? "Apparence · fond du site (conservé, inactif)"
          : "Apparence · fond du site",
      );
  } else if (cmsDocumentReferences([], menu).has(id)) result.push("Navigation");
  for (const page of pages)
    page.blocks.forEach((block, index) => {
      const refs =
        kind === "image"
          ? cmsImageReferences([{ ...page, blocks: [block] }])
          : cmsDocumentReferences([{ ...page, blocks: [block] }], []);
      if (refs.has(id))
        result.push(
          `${page.title} · section ${index + 1}${block.type === "cover" && block.backgroundImageId === id ? " · fond du hero" : ""}`,
        );
    });
  return result;
}
